import mapActions from './mapActions';

export default mapActions('rewards', {
	fetchAll_url: (obj) => `/api/rewards/${obj.year}/${obj.month}`
});
